import React from 'react';
import { Box } from '@mui/material';
import { AttendanceCheckpointModel, AttendanceStateDto, CitizenAttendanceStatisticsLessonModel } from '../../../../api-service/clients';
import { ColorPalette } from '../../../../components/config';
import { formatTime } from '../../utils';
import { getAttendanceStateDisplayName } from '../../attendance-state-texts';
import { Container } from '../../../../components/container';
import { Row } from '../../../../components/row';
import { Cell } from '../../../../components/cell';
import { formatDateTime } from '../../../../utilities';
import { getAttendanceStateTextColor, getStatisticsStateColor } from '../../components/attendance-protocol/utils';

interface IAttendanceStatisticsResultTableDetails {
  lesson: CitizenAttendanceStatisticsLessonModel;
}

export function AttendanceStatisticsResultTableDetails(props: IAttendanceStatisticsResultTableDetails) {
  const { lesson } = props;
  const hasChecks = Boolean(lesson.startCheck) || Boolean(lesson.endCheck);

  return (
    <Box bgcolor={ColorPalette.WHITE}>
      <Box ml={6} p={2} display="flex">
        <Container sx={{ width: '100%' }}>
          {lesson.startCheck && <RegistrationDetails attendanceCheckpoint={lesson.startCheck} />}
          {lesson.endCheck && <RegistrationDetails attendanceCheckpoint={lesson.endCheck} />}
          {!hasChecks && <Box sx={{ fontSize: '0.875em' }}>{getNoChecksLabel(lesson)}</Box>}
        </Container>
      </Box>
    </Box>
  );
}

function getNoChecksLabel(lesson: CitizenAttendanceStatisticsLessonModel) {
  return lesson.isStartCheckEnabled || lesson.isEndCheckEnabled ? 'Ingen registreringer' : 'Ingen fremmødetjek';
}

interface IRegistrationDetailsProps {
  attendanceCheckpoint: AttendanceCheckpointModel;
}

function RegistrationDetails(props: IRegistrationDetailsProps) {
  const { attendanceCheckpoint } = props;

  // Only a check the citizen turned up for carries a meeting time. Absence rows written before the
  // field was made trustworthy can still hold the moment the caseworker clicked.
  const isPresent = attendanceCheckpoint.state === AttendanceStateDto.OnTime || attendanceCheckpoint.state === AttendanceStateDto.NotOnTime;
  const meetingTime = isPresent ? attendanceCheckpoint.checkInTime : undefined;

  return (
    <>
      <Box>Fremmødetjek {meetingTime && `(${formatTime(meetingTime)})`}</Box>
      <Row>
        <Cell size="thirds">
          <Box>
            <Box sx={{ fontWeight: 600, fontSize: '0.875em' }}>Registreret som</Box>
            <Box
              sx={{
                fontSize: '0.875em',
                backgroundColor: getStatisticsStateColor(attendanceCheckpoint.state),
                width: 'fit-content',
                padding: '0 5px',
                color: getAttendanceStateTextColor(attendanceCheckpoint.state),
              }}
            >
              {getAttendanceStateDisplayName(attendanceCheckpoint.state)}
            </Box>
          </Box>
        </Cell>
        <Cell size="thirds">
          <Box>
            <Box sx={{ fontWeight: 600, fontSize: '0.875em' }}>Registreringstidspunkt</Box>
            <Box sx={{ fontSize: '0.875em' }}>{formatDateTime(attendanceCheckpoint.registeredOn)}</Box>
          </Box>
        </Cell>
        <Cell size="thirds">
          <Box>
            <Box sx={{ fontWeight: 600, fontSize: '0.875em' }}>Registreret af</Box>
            <Box sx={{ fontSize: '0.875em' }}>{attendanceCheckpoint.registeredByName}</Box>
          </Box>
        </Cell>
      </Row>
    </>
  );
}
